/**
 * Collection GA4 ecommerce tracking.
 * Only product-list elements marked by main-collection.liquid are tracked.
 */
(function () {
  'use strict';

  var state = window.__photopriCollectionAnalytics;
  if (!state) {
    state = {
      sentLists: Object.create(null),
      sentItems: Object.create(null),
      observed: false,
      boundLists: typeof WeakSet === 'function' ? new WeakSet() : null
    };
    window.__photopriCollectionAnalytics = state;
  }

  function track(name, payload) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) { /* UI を止めない */ }
  }

  function itemFrom(card) {
    try {
      var price = Number(card.getAttribute('data-ga-price'));
      return {
        item_id: card.getAttribute('data-ga-item-id') || '',
        item_name: card.getAttribute('data-ga-item-name') || '',
        index: Number(card.getAttribute('data-ga-index')) || 1,
        price: Number.isFinite(price) ? price : 0
      };
    } catch (e) {
      return null;
    }
  }

  function listPayload(list, cards) {
    try {
      var items = [];
      for (var i = 0; i < cards.length; i += 1) {
        var item = itemFrom(cards[i]);
        if (item && item.item_id) items.push(item);
      }
      if (!items.length) return null;
      // 🔴 item_list_id が送信元の識別子になる(2026-08-27 実測)。
      //    Google & YouTube チャネルの Web Pixel は view_item_list を送るが
      //    item_list_id を一切入れない(GA4上は全て (not set))。
      //    こちらは必ず handle を入れるので、分析時に item_list_id の有無で
      //    「テーマ側(被覆~100%)」と「チャネル側(被覆~10%)」を完全に分離できる。
      //    → 空なら送らない。送ると見分けが付かず二重計上に混ざる。
      var listId = list.getAttribute('data-ga-list-id') || '';
      if (!listId) return null;
      return {
        item_list_id: listId,
        item_list_name: list.getAttribute('data-ga-list-name') || '',
        items: items
      };
    } catch (e) {
      return null;
    }
  }

  // 🔴 無限スクロール対策(2026-08-27 artgraph 実測)。
  //    グリッドに商品が追記される実装では、毎回グリッド全体を送ると
  //    同じ商品が 35→70→105 と累積で重複計上される。
  //    リストごとに送信済み item_id を持ち、**新しく現れた商品だけ**送る。
  function deltaItems(listId, items) {
    var seen = state.sentItems[listId];
    if (!seen) { seen = state.sentItems[listId] = Object.create(null); }
    var fresh = [];
    for (var i = 0; i < items.length; i += 1) {
      var id = items[i].item_id;
      if (!seen[id]) { seen[id] = true; fresh.push(items[i]); }
    }
    // 🔴 上限でリセットしてはいけない。DOM に上限超の商品が残っている場合、
    //    次の変更で全件が「新規」に戻り、以後 DOM 変更のたびに全件再送し続ける。
    //    リセットせず、異常水準に達したらそのリストの送信を打ち切る。
    if (Object.keys(seen).length > 5000) return [];
    return fresh;
  }

  function listKey(payload) {
    try {
      return payload.item_list_id + '|' + payload.items.map(function (item) {
        return item.item_id;
      }).join(',');
    } catch (e) {
      return '';
    }
  }

  function bindList(list) {
    try {
      if (state.boundLists && state.boundLists.has(list)) return;
      list.addEventListener('click', function (event) {
        try {
          var target = event.target;
          if (!target || typeof target.closest !== 'function') return;
          // 🔴 カード内の任意のクリックを拾わないこと(2026-08-27 artgraph 本番で実測)。
          //    比較チェックボックス・お気に入り・クイック追加・スウォッチ・動画再生・
          //    クイックビューでも発火し、「一覧→商品詳細のCTR」が偽陽性で膨らむ。
          //    商品ページへ向かう <a> のクリックだけを select_item とする。
          var link = target.closest('a[href]');
          if (!link) return;
          var href = link.getAttribute('href') || '';
          if (href.indexOf('/products/') === -1) return;
          var card = link.closest('[data-ga-item-id]');
          if (!card || !list.contains(card)) return;
          var item = itemFrom(card);
          if (!item || !item.item_id) return;
          var sListId = list.getAttribute('data-ga-list-id') || '';
          if (!sListId) return;
          track('select_item', {
            item_list_id: sListId,
            item_list_name: list.getAttribute('data-ga-list-name') || '',
            items: [item]
          });
        } catch (e) { /* UI を止めない */ }
      });
      if (state.boundLists) state.boundLists.add(list);
    } catch (e) { /* UI を止めない */ }
  }

  function inspectLists() {
    try {
      var lists = document.querySelectorAll('[data-ga-list-id][data-ga-list-name]');
      for (var i = 0; i < lists.length; i += 1) {
        var list = lists[i];
        bindList(list);
        var payload = listPayload(list, list.querySelectorAll('[data-ga-item-id]'));
        if (!payload) continue;
        var fresh = deltaItems(payload.item_list_id, payload.items);
        if (!fresh.length) continue;   // 新しい商品が無ければ送らない
        payload.items = fresh;
        track('view_item_list', payload);
      }
    } catch (e) { /* UI を止めない */ }
  }

  // 🔴 DOM変更ごとに inspectLists を直接回さないこと(2026-08-27)。
  //    body/subtree の childList はカートドロワー・facet・画像の遅延読込・
  //    instant prefetch で頻発する。1フレームに1回へ畳む。
  //    非コレクション面では list が0件なので querySelectorAll 1回で即抜ける。
  var scheduled = false;
  function scheduleInspect() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; inspectLists(); };
    if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(run);
    else setTimeout(run, 100);
  }

  function observeLists() {
    try {
      if (state.observed || !document.body || typeof MutationObserver !== 'function') return;
      state.observed = true;
      new MutationObserver(scheduleInspect).observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* UI を止めない */ }
  }

  function initialize() {
    observeLists();
    inspectLists();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
